import { noop } from "lodash";
import { UTCDate } from "./date";

export function EnableFeature(enabled: boolean): ClassDecorator {
  return (target) => {
    if (!enabled) {
      Object.getOwnPropertyNames(target.prototype).forEach((k) => (target.prototype[k] = noop));
    }
    return target;
  };
}

export const ENABLE_FACEBOOK = false;
export const ENABLE_TALENT_POOL = true;
export const SHOW_TALENT_POOL_UI = ENABLE_TALENT_POOL && false;
export const ENABLE_BILLING = true;
/**
 * Reads sharing matrix rows from before the rollout migrations as the rebuilt matrix will have them, until v307 has swapped it in. Remove with
 * the next deployment, together with `readLegacyMatrixRow`.
 */
export const ENABLE_LEGACY_MATRIX_READ_COMPAT = true;
export const ENABLE_CHAT = true;
export const ENABLE_ADDON_BILLING = ENABLE_CHAT;
export const ENABLE_USER_BILLING = true;
export const ENABLE_PROPERTY_AND_CASUALTY_INSURANCES = true;
export const ENABLE_PROCESS_AI = true;
export const ENABLE_USER_BILLING_OVERDRAW_NOTIFICATION = true;
export const ENABLE_BROKER_MANDATE_DOCUMENT_VALIDATION = false;
export const ENABLE_DOCUSEAL_SIGNING = true;
export const ALLOW_SES_CANDIDATE_VERIFICATION = false;

/** User billing restrictions (creation limits, extra cost warnings) are enforced starting from this date */
export const USER_BILLING_START_DATE = UTCDate.fromYMD(2026, 5, 1); // 2026-06-01

export const CHAT_FEATURE_TOGGLES = {
  BroadCastEnabled: ENABLE_CHAT && false,
  CandidateChatEnabled: ENABLE_CHAT && false,
} as const;

const TalentPoolAddonServiceEnabledForOrgs_Dev: string[] = [
  "27eb09f1-4540-48d5-9f1b-06faf81f3b7e", // TP - Cheese Provider
  "8cbdf0fd-dd9e-4150-8923-17f5d571a3bf", // Online Application Org
  "87e81b29-38f4-466d-a3b1-2a6867e7843f", // PM Agency
  "9db784d2-11cd-49b6-b3bb-7f7e1f072b06", // Go PSA
  "83394f70-d223-4185-94be-750060fb9812", // Medwing
  "5f4f5785-c39d-406c-be92-c6394e81c4b8", // Klinik Wohlgesund
];

const TalentPoolAddonServiceEnabledForOrgs_Test: string[] = [
  "7005750f-81c0-4f93-a905-7e2ef0df7e85", // PM Agency
  "1249a53d-1c77-4ea3-b100-6c4f104865b3", // PSA Smart Recruitment
];
const TalentPoolAddonServiceEnabledForOrgs_Prod: string[] = [];

export const TalentPoolFeatureToggles = {
  WebsitePoolsEnabled: SHOW_TALENT_POOL_UI,
  AddonServiceEnabledForOrgs: !SHOW_TALENT_POOL_UI
    ? []
    : [
        ...TalentPoolAddonServiceEnabledForOrgs_Dev,
        ...TalentPoolAddonServiceEnabledForOrgs_Test,
        ...TalentPoolAddonServiceEnabledForOrgs_Prod,
      ],
} as const;
